import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * shadcn/ui's standard `cn()` helper. `clsx` resolves conditionals; `twMerge`
 * dedupes conflicting Tailwind classes (e.g. `cn('p-2', condition && 'p-4')`
 * yields `p-4` not `p-2 p-4`). Use everywhere we'd otherwise template-string
 * className values.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
